import Vue from "vue";
import { format, parseISO } from "date-fns";

Vue.filter("dateTime", (date) => {
  if (date) {
    return format(parseISO(date), "Pp");
  }
  return "";
});

Vue.filter("date", (date) => {
  if (date && Object.prototype.toString.call(date) === "[object Date]") {
    return format(date, "MM/dd/yyyy");
  }
  if (date) {
    return format(parseISO(date), "MM/dd/yyyy");
  }
  return "";
});

Vue.filter("dollarsCents", (amount) => {
  if (!amount) amount = 0;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return formatter.format(amount);
});

Vue.filter("facilityStatus", (status) => {
  if (status === 0) return "Inactive";
  else if (status === 1) return "Active";
  else if (status === 2) return "In Moderation";
  else if (status === 3) return "Blocked";
  else if (status === 8) return "Published";
  else if (status === 9) return "redirected";
  else if (status == 10) return "unpublished";
});

Vue.filter("snakeToSentence", (text) => {
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
});

Vue.filter("formatPrevPayment", (data) => {
  //console.log(typeof data);
  if (typeof data !== "object") {
    data = JSON.parse(data);
  }
  const price = 0 - data.total;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
  return formatter.format(price);
});
